<template>
  <viewPersonnePhysique
    ref="view"
    :idContact="idContact"
    :donneesConfidentiellesVisibles="donneesConfidentiellesVisibles"
    :enums="enums"
    :form="form"
    :control="control"
    :enModeCreation="enModeCreation"
    :enModeReactivation="enModeReactivation"
    :pphReadonly="control.enDemandeAjoutContact"
    @valideNouveauContact="valideNouveauContact"
    @supprimerContact="supprimerContact"
    @idContact="setIdContact"
  >
    <entiteActions
      :type="'contact'"
      :id="idContactSelectionne"
      :demandeModication="demandeContactModificationPossible"
      :demandeSuppression="demandeContactModificationPossible"
      :enModeReactivation="demandeActivationContactPossible"
    >
      <v-btn
        text
        v-if="demandeAjoutContactPossible"
        @click="ajouterDemandeContact"
      >
        Lier à une Personne Morale
      </v-btn>

      <template v-if="demandeContactModificationPossible">
        <v-btn text @click="associerInstance()">Ajout d'instances</v-btn>

        <dialogAssociationInstance ref="dialogAssociationInstance" />
      </template>
      <v-btn
        text
        v-if="demandeActivationContactPossible"
        @click="reactiverContact"
      >
        Réactiver
      </v-btn>
    </entiteActions>

    <template
      v-if="
        this.control.enDemandeModification ||
          this.control.enDemandeCreation ||
          this.control.enDemandeSuppression
      "
      #zoneBasse
    >
      <v-list-item>
        <v-list-item-content two-line class="pt-0">
          <v-list-item-title class="headline"
            >Raison de la demande</v-list-item-title
          >
          <v-list-item-subtitle
            >Veuillez saisir les raisons motivant cette
            demande</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              counter
              filled
              label="Commentaire"
              v-model="commentaire"
              :rules="[size255Rule(), serveurRule('commentaire')]"
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </viewPersonnePhysique>
</template>

<script>
import moment from 'moment';
import { getInternational } from '@/components/telephone/telephoneUtil';
import { nettoyageTelephone } from '@/view/personnephysique/personnephysiqueUtils';
import ViewPersonnePhysique from './ViewPersonnePhysique';
import EditeurEntite from '@/plugins/mixins/EditeurEntite';
import { routeEnter, routeUpdate } from '@/utils/entite';
import toasted from '@/utils/toasted';

const routesAction = (withId, withNew) => {
  withId(
    id => `personne-physique/${id}`,
    (vm, body) => {
      vm.initForm(body);
      vm.selectionContact();
    },
  );
  withNew('enums/personnephysique', (vm, body) => vm.initNew(body));
};

export default {
  components: {
    viewPersonnePhysique: ViewPersonnePhysique,
  },
  mixins: [EditeurEntite],
  props: {
    enModeCreation: {
      type: Boolean,
      default: false,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    deleted: {
      type: Boolean,
      default: false,
    },
  },
  beforeRouteEnter: routeEnter(routesAction),
  beforeRouteUpdate: routeUpdate(routesAction),
  data() {
    return {
      enums: {
        civilites: [],
        fonctions: [],
        typesContact: [],
        typesAccesAgil: [],
        typesAcces: [],
        typesLait: [],
        personnesMorales: [],
        typeParticipant: [],
      },
      idContact: null,
      idContactSelectionne: null,
      donneesConfidentiellesVisibles: false,
      commentaire: null,
      form: {
        id: null,
        nom: null,
        prenoms: null,
        civilite: {
          id: null,
          libelle: null,
        },
        telephone: null,
        confidentialiteTelephone: null,
        smsAccepte: null,
        mailPrincipal: null,
        confidentialiteMail: null,
        contacts: [],
        accesAgil: null,
        acces: null,
        deleted: null,

        //RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },
    };
  },

  computed: {
    contactsVisible() {
      if (!this.enModeReactivation) {
        return this.form.contacts.filter(c => !c.deleted);
      } else {
        return this.form.contacts.filter(c => c.deleted);
      }
    },
    contactSelectionne() {
      const contacts = this.contactsVisible;
      if (this.idContact < contacts.length) return contacts[this.idContact];
      return null;
    },
    demandeContactModificationPossible() {
      return (
        this.contactSelectionne &&
        this.contactSelectionne.edition === 'DEMANDE' &&
        !this.contactSelectionne.deleted
      );
    },
    demandeAjoutContactPossible() {
      return (
        this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.control.enDemandeModification &&
        !this.enModeReactivation &&
        this.control.edition !== 'DIRECT'
      );
    },
    demandeActivationContactPossible() {
      return this.enModeReactivation;
    },
  },

  methods: {
    initForm(loaded) {
      this.form.dateCreation = loaded.dateCreation || null;
      this.form.chargeCreation = loaded.chargeCreation || null;
      this.form.dateModification = loaded.dateModification || null;
      this.form.demandeurCreation = loaded.demandeurCreation || null;
      this.form.chargeModification = loaded.chargeModification || null;

      //injection du droit d'edition
      this.control.edition = loaded.edition;

      this.form.id = loaded.id || null;
      this.form.identifiant = loaded.identifiant || null;
      this.form.nom = loaded.nom || null;
      this.form.prenoms = loaded.prenoms || null;
      this.form.civilite = loaded.civilite || null;
      this.form.telephone = getInternational(loaded.telephone) || null;
      this.form.confidentialiteTelephone =
        loaded.confidentialiteTelephone || null;
      this.form.deleted = loaded.deleted || null;
      this.form.smsAccepte = loaded.smsAccepte || null;
      this.form.mailPrincipal = loaded.mailPrincipal || null;
      this.form.confidentialiteMail = loaded.confidentialiteMail || null;
      this.form.contacts = loaded.contacts
        .filter(c => c.deleted === this.deleted)
        .map(c => {
          c.invalid = 0;
          return c;
        });
      this.form.accesAgil = [...loaded.accesAgil];
      this.form.acces = [...loaded.acces];

      this.donneesConfidentiellesVisibles =
        loaded.donneesConfidentiellesVisibles;
    },
    selectionContact() {
      const contactId = this.$route.params.contact;

      this.contactsVisible.forEach((item, index) => {
        //sélection automatique du contact
        if (item.id === contactId) {
          this.idContact = index;
          this.idContactSelectionne = this.contactsVisible[index].id;
        }
      });
    },
    associerInstance() {
      var contact = this.form.contacts[this.idContact];
      this.$refs.dialogAssociationInstance.show(contact);
    },
    initEnums(body) {
      const enums = this.enums;
      enums.civilites = body.civilites;
      enums.fonctions = body.fonctions;
      enums.typesContact = body.typesContact;
      enums.typesAccesAgil = body.typesAccesAgil;
      enums.typesLait = body.typesLait;
      enums.typesAcces = body.typesAcces;
      enums.typeParticipant = body.typesParticipant;

      // les informations des personnes morales
      enums.personnesMorales = body.personnesMorales || [];
    },
    initNew(body) {
      this.initForm({
        contacts: [],
        accesAgil: [],
        acces: [],
        donneesConfidentiellesVisibles: true,
      });
      this.initEnums(body);
      this.__initEdition();

      // on utilise les props pour savoir cela
      this.control.enDemandeCreation = this.enDemandeCreation;
      this.control.enCreation = !this.enDemandeCreation;
      this.control.readonly = false;
      this.getForms().forEach(f => {
        if (f) {
          f.resetValidation();
        }
      });
    },
    redirectionApresCreation() {
      //le callback pour aller vers le détail de la personne créée
      if (this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE')) {
        const route = this.$liens().personnePhysique(this.form.id);
        this.control.readonly = true;
        this.$router.push(route);
      } else {
        this.$router.push({ name: 'workflow/mesdemandes' });
      }
    },
    actionApresAnnulation(control) {
      if (
        (control.enDemandeCreation && !control.enDemandeAjoutContact) ||
        control.enCreation
      ) {
        this.$router.push({ name: 'home' });
      } else if (control.enDemandeAjoutContact) {
        this.control.readonly = true;
      }
    },
    creationPromiseEnums() {
      //pour une modification en directe
      const api = this.form.id
        ? this.$api(`enums/personnephysique/${this.form.id}`)
        : this.$api('enums/personnephysique');
      return api.get().then(response => {
        const body = response.body;
        this.initEnums(body);
      });
    },
    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },
    creationPromiseSauvegarde(id, form) {
      const pph = nettoyageTelephone(form);

      if (this.control.enDemandeModification) {
        pph.contacts = [pph.contacts[this.idContact]];
        pph.commentaire = this.commentaire;
        return this.$api(`workflow/personne-physique/${id}`).post(pph);
      } else if (this.control.enDemandeCreation) {
        if (this.control.enDemandeAjoutContact) {
          //rajout de contact
          const contact = { ...pph.contacts[this.idContact] };
          contact.idDemandePersonneMorale =
            pph.contacts[this.idContact].demandePersonneMorale;
          contact.commentaire = this.commentaire;
          return this.$api(`workflow/personne-physique/${id}/contact`).post(
            contact,
          );
        } else {
          //creation ex-nihilo
          pph.contacts = [pph.contacts[this.idContact]];
          pph.commentaire = this.commentaire;
          pph.idDemandePersonneMorale =
            pph.contacts[this.idContact].demandePersonneMorale;
          return this.$api('workflow/personne-physique').post(pph);
        }
      } else if (this.control.enDemandeSuppression) {
        const contact = { ...pph.contacts[this.idContact] };
        return this.$api(
          `workflow/personne-physique/suppression/${contact.id}`,
        ).post({
          commentaire: this.commentaire,
        });
      } else if (this.control.enCreation) {
        //creation ex-nihilo
        pph.contacts = [pph.contacts[this.idContact]];
        return this.$api('personne-physique').put(pph);
      } else {
        return this.$api(`personne-physique/${id}`).post(pph);
      }
    },
    __valideNouveauContact(personneMorale) {
      const dateLimiteValidite = moment()
        .add(2, 'years')
        .format('YYYY-MM-DD');

      this.idContact = this.form.contacts.length;
      this.form.contacts.push({
        personneMorale: {
          id: personneMorale.id,
          raisonSociale: personneMorale.raisonSociale,
          nomUsuel: personneMorale.nomUsuel,
        },
        demandePersonneMorale: personneMorale.idDemande,
        invalid: 0,
        id: null,
        telPP: false,
        mailPP: false,
        collaborateurMDL: personneMorale.collaborateurMDL || false,
        principal: this.form.contacts.length === 0,
        adresses: [],
        telephones: [],
        typeLait: [],
        dateLimiteValidite,
      });
    },
    valideNouveauContact(personneMorale) {
      const idPM = personneMorale.id;
      if (idPM == null) {
        this.$api('enums/personnephysique/personnemorale/0')
          .get()
          .then(response => {
            const body = response.body;
            this.initEnums(body);
            this.__valideNouveauContact(personneMorale);
            if ('demande' === personneMorale.type) {
              this.control.enDemandeCreation = true;
              this.control.readonly = false;
              this.control.enDemandeAjoutContact = true;
            }
          });
      } else {
        if ('demande' === personneMorale.type) {
          // il faut charger les informations de la personne specifique + les informations de la personne
          this.$api(`enums/personnephysique/personnemorale/${idPM}`)
            .get()
            .then(response => {
              const body = response.body;
              this.initEnums(body);

              this.__initEdition();
              this.__valideNouveauContact(personneMorale);
              this.control.enDemandeCreation = true;
              this.control.readonly = false;
              this.control.enDemandeAjoutContact = true;
              this.getForms().forEach(f => f.resetValidation());
            });
        } else {
          // si les informations de la personne morale n'existent pas, il faut chercher les informations  divisions et contacts de la PM .
          const pmExists = this.enums.personnesMorales.some(p => idPM === p.id);
          if (!pmExists) {
            this.$api(`enums/personnephysique/simple-personnemorale/${idPM}`)
              .get()
              .then(response => {
                const body = response.body;
                this.enums.personnesMorales.push(body);
                this.__valideNouveauContact(personneMorale);
              });
          } else {
            this.__valideNouveauContact(personneMorale);
          }
        }
      }
    },
    ajouterDemandeContact() {
      this.$refs.view.ajouterContact('demande');
    },
    supprimerContact(index) {
      this.form.contacts.splice(index, 1);
    },
    reactiverContact() {
      const contact = this.contactSelectionne;
      return this.$api(`workflow/personne-physique/reactivation/${contact.id}`)
        .post()
        .then(() => {
          toasted.info('Contact réactivé');
          this.$router.push({ name: 'administration/corbeille/corbeille' });
        });
    },
    setIdContact(index) {
      this.idContact = index;
      this.idContactSelectionne = this.form.contacts[index].id;
    },
  },
};
</script>
